import type { Translation } from '@teamhanko/hanko-elements';
import { en } from '@teamhanko/hanko-elements/i18n/en';

export const hankoFi: Translation = {
  ...en,
  headlines: {
    ...en.headlines,
    error: 'Tapahtui virhe',
    accountNotFound: 'Tiliä ei löytynyt',
    loginEmail: 'Kirjaudu tai luo tili',
    loginEmailNoSignup: 'Kirjaudu sisään',
    loginFinished: 'Kirjautuminen onnistui',
    loginPasscode: 'Syötä kertakäyttökoodi',
    loginPassword: 'Syötä salasana',
    registerAuthenticator: 'Luo passkey',
    registerConfirm: 'Luodaanko tili?',
    registerPassword: 'Aseta uusi salasana',
    securityKeyLogin: 'Turva-avain',
    securityKeySetUp: 'Lisää turva-avain',
    trustDevice: 'Luotatko tähän selaimeen?',
    mfaSetUp: 'Ota kaksivaiheinen tunnistus käyttöön',
    otpLogin: 'Tunnistuskoodi',
    otpSetUp: 'Ota tunnistussovellus käyttöön',
    profileEmails: 'Sähköpostit',
    profilePassword: 'Salasana',
    profilePasskeys: 'Passkeyt',
    isPrimaryEmail: 'Ensisijainen sähköpostiosoite',
    setPrimaryEmail: 'Aseta ensisijainen sähköposti',
    createEmail: 'Syötä uusi sähköposti',
    createUsername: 'Syötä uusi käyttäjätunnus',
    emailVerified: 'Vahvistettu',
    emailUnverified: 'Vahvistamaton',
    emailDelete: 'Poista',
    renamePasskey: 'Nimeä passkey uudelleen',
    deletePasskey: 'Poista passkey',
    lastUsedAt: 'Käytetty viimeksi',
    createdAt: 'Luotu',
    connectedAccounts: 'Yhdistetyt tilit',
    deleteAccount: 'Poista tili',
    signIn: 'Kirjaudu sisään',
    signUp: 'Luo tili',
    selectLoginMethod: 'Valitse kirjautumistapa',
    setupLoginMethod: 'Määritä kirjautumistapa',
    lastUsed: 'Nähty viimeksi',
    ipAddress: 'IP-osoite',
    revokeSession: 'Katkaise istunto',
    profileSessions: 'Istunnot',
    renameSecurityKey: 'Nimeä turva-avain uudelleen',
    deleteSecurityKey: 'Poista turva-avain',
    securityKeys: 'Turva-avaimet',
    authenticatorApp: 'Tunnistussovellus',
    authenticatorAppAlreadySetUp: 'Tunnistussovellus on käytössä',
    authenticatorAppNotSetUp: 'Ota tunnistussovellus käyttöön',
    deleteIdentity: 'Poista yhteys',
  },
  texts: {
    ...en.texts,
    enterPasscode: 'Syötä sähköpostiisi lähetetty kertakäyttökoodi.',
    enterPasscodeNoEmail: 'Syötä ensisijaiseen sähköpostiisi lähetetty kertakäyttökoodi.',
    setupPasskey:
      'Kirjaudu tilillesi helposti ja turvallisesti passkeylla. Biometriset tiedot säilyvät vain omilla laitteillasi.',
    createAccount: 'Osoitteelle "{emailAddress}" ei löydy tiliä. Haluatko luoda uuden tilin?',
    noAccountExists: 'Osoitteelle "{emailAddress}" ei löydy tiliä.',
    otpEnterVerificationCode: 'Syötä tunnistussovelluksen näyttämä kertakäyttökoodi alle:',
    otpLogin: 'Avaa tunnistussovellus ja syötä kertakäyttökoodi alle.',
    otpScanQRCode:
      'Skannaa QR-koodi tunnistussovelluksella tai syötä salainen avain sovellukseen käsin.',
    otpSecretKey: 'OTP-salainen avain',
    passwordFormatHint: 'Pituuden täytyy olla {minLength}–{maxLength} merkkiä.',
    securityKeyLogin:
      'Yhdistä tai aktivoi turva-avain ja jatka kirjautumista seuraamalla selaimen ohjeita.',
    trustDevice:
      'Kun luotat tähän selaimeen, et tarvitse tunnistussovelluksen koodia tai turva-avainta seuraavalla kirjautumiskerralla.',
    isPrimaryEmail: 'Tätä sähköpostiosoitetta käytetään tarvittaessa yhteydenottoihin.',
    securityKeySetUp:
      'Käytä erillistä turva-avainta USB:n, Bluetoothin tai NFC:n kautta tai matkapuhelintasi.',
    setPrimaryEmail: 'Aseta tämä sähköpostiosoite ensisijaiseksi yhteydenottoja varten.',
    emailVerified: 'Tämä sähköpostiosoite on vahvistettu.',
    emailUnverified: 'Tätä sähköpostiosoitetta ei ole vahvistettu.',
    emailDelete: 'Jos poistat tämän sähköpostiosoitteen, sitä ei voi enää käyttää kirjautumiseen.',
    renamePasskey: 'Anna passkeylle nimi.',
    deletePasskey: 'Poista tämä passkey tililtasi.',
    deleteAccount:
      'Haluatko varmasti poistaa tämän tilin? Kaikki tiedot poistetaan heti eikä niitä voi palauttaa.',
    selectLoginMethodForFutureLogins: 'Valitse kirjautumistapa tulevia kirjautumisia varten.',
    howDoYouWantToLogin: 'Miten haluat kirjautua?',
    mfaSetUp:
      'Suojaa tilisi kaksivaiheisella tunnistuksella. Se lisää kirjautumiseen ylimääräisen varmistusvaiheen.',
    renameSecurityKey: 'Anna turva-avaimelle nimi.',
    deleteSecurityKey: 'Poista tämä turva-avain tililtasi.',
    authenticatorAppAlreadySetUp:
      'Tilisi on suojattu tunnistussovelluksella, joka luo vaihtuvia kertakäyttökoodeja.',
    authenticatorAppNotSetUp:
      'Suojaa tilisi tunnistussovelluksella, joka luo vaihtuvia kertakäyttökoodeja.',
  },
  labels: {
    ...en.labels,
    authenticatorApp: 'Tunnistussovellus',
    authenticatorAppAdd: 'Ota käyttöön',
    authenticatorAppManage: 'Hallitse tunnistussovellusta',
    or: 'tai',
    no: 'ei',
    yes: 'kyllä',
    email: 'Sähköposti',
    continue: 'Jatka',
    copied: 'kopioitu',
    configured: 'käytössä',
    skip: 'Ohita',
    save: 'Tallenna',
    password: 'Salasana',
    passkey: 'Passkey',
    passcode: 'Kertakäyttökoodi',
    signInPassword: 'Kirjaudu salasanalla',
    signInPasscode: 'Kirjaudu kertakäyttökoodilla',
    forgotYourPassword: 'Unohditko salasanasi?',
    back: 'Takaisin',
    registerAuthenticator: 'Luo passkey',
    securityKey: 'Turva-avain',
    securityKeyUse: 'Käytä turva-avainta',
    signIn: 'Kirjaudu sisään',
    signInPasskey: 'Kirjaudu passkeylla',
    signUp: 'Luo tili',
    sendNewPasscode: 'Lähetä uusi koodi',
    staySignedIn: 'Pysy kirjautuneena',
    trustDevice: 'Luota tähän selaimeen',
    passwordRetryAfter: 'Yritä uudelleen {passwordRetryAfter}',
    passcodeResendAfter: 'Pyydä uusi koodi {passcodeResendAfter}',
    useAnotherMethod: 'Käytä toista tapaa',
    unverifiedEmail: 'vahvistamaton',
    primaryEmail: 'ensisijainen',
    setAsPrimaryEmail: 'Aseta ensisijaiseksi',
    verify: 'Vahvista',
    delete: 'Poista',
    newEmailAddress: 'Uusi sähköpostiosoite',
    newPassword: 'Uusi salasana',
    rename: 'Nimeä uudelleen',
    newPasskeyName: 'Uusi passkeyn nimi',
    addEmail: 'Lisää sähköposti',
    createPasskey: 'Luo passkey',
    webauthnUnsupported: 'Selaimesi ei tue passkeyta',
    signInWith: 'Jatka palvelulla {provider}',
    deleteAccount: 'Kyllä, poista tämä tili.',
    emailOrUsername: 'Sähköposti tai käyttäjätunnus',
    username: 'Käyttäjätunnus',
    optional: 'valinnainen',
    dontHaveAnAccount: 'Eikö sinulla ole tiliä?',
    alreadyHaveAnAccount: 'Onko sinulla jo tili?',
    changePassword: 'Vaihda salasana',
    setPassword: 'Aseta salasana',
    changeUsername: 'Vaihda käyttäjätunnus',
    setUsername: 'Aseta käyttäjätunnus',
    revoke: 'Katkaise',
    currentSession: 'Nykyinen istunto',
    newSecurityKeyName: 'Uusi turva-avaimen nimi',
    createSecurityKey: 'Lisää turva-avain',
    lastUsed: 'Käytetty viimeksi',
    connectAccount: 'Yhdistä tili',
  },
  errors: {
    ...en.errors,
    somethingWentWrong: 'Tapahtui tekninen virhe. Yritä myöhemmin uudelleen.',
    requestTimeout: 'Pyyntö aikakatkaistiin.',
    invalidPassword: 'Väärä sähköposti tai salasana.',
    invalidPasscode: 'Annettu kertakäyttökoodi ei ollut oikein.',
    passcodeAttemptsReached:
      'Kertakäyttökoodi syötettiin väärin liian monta kertaa. Pyydä uusi koodi.',
    tooManyRequests: 'Liian monta pyyntöä. Odota hetki ennen uutta yritystä.',
    unauthorized: 'Istuntosi on vanhentunut. Kirjaudu uudelleen.',
    invalidWebauthnCredential: 'Tätä passkeyta ei voi enää käyttää.',
    passcodeExpired: 'Kertakäyttökoodi on vanhentunut. Pyydä uusi.',
    userVerification:
      'Käyttäjän vahvistus vaaditaan. Varmista, että laitteessa on PIN tai biometrinen tunnistus.',
    emailAddressAlreadyExistsError: 'Sähköpostiosoite on jo käytössä.',
    maxNumOfEmailAddressesReached: 'Uusia sähköpostiosoitteita ei voi enää lisätä.',
    thirdPartyAccessDenied:
      'Pääsy evätty. Käyttäjä peruui pyynnön tai palveluntarjoaja esti pääsyn.',
    thirdPartyMultipleAccounts:
      'Tiliä ei voi tunnistaa. Sähköpostiosoite on käytössä usealla tilillä.',
    thirdPartyUnverifiedEmail:
      'Sähköpostin vahvistus vaaditaan. Vahvista sähköposti palveluntarjoajalla.',
    signupDisabled: 'Tilien rekisteröinti on poistettu käytöstä.',
    handlerNotFoundError:
      'Nykyistä vaihetta ei tueta tämän sovellusversion kanssa. Yritä myöhemmin uudelleen.',
  },
  flowErrors: {
    ...en.flowErrors,
    technical_error: 'Tapahtui tekninen virhe. Yritä myöhemmin uudelleen.',
    flow_expired_error: 'Istunto on vanhentunut. Aloita uudelleen.',
    value_invalid_error: 'Syötetty arvo on virheellinen.',
    passcode_invalid: 'Annettu kertakäyttökoodi ei ollut oikein.',
    passkey_invalid: 'Tätä passkeyta ei voi enää käyttää.',
    passcode_max_attempts_reached:
      'Kertakäyttökoodi syötettiin väärin liian monta kertaa. Pyydä uusi koodi.',
    rate_limit_exceeded: 'Liian monta pyyntöä. Odota hetki ennen uutta yritystä.',
    unknown_username_error: 'Käyttäjätunnusta ei tunneta.',
    unknown_email_error: 'Sähköpostiosoitetta ei tunneta.',
    username_already_exists: 'Käyttäjätunnus on jo käytössä.',
    invalid_username_error: 'Käyttäjätunnuksessa saa olla vain kirjaimia, numeroita ja alaviivoja.',
    email_already_exists: 'Sähköposti on jo käytössä.',
    not_found: 'Pyydettyä kohdetta ei löytynyt.',
    operation_not_permitted_error: 'Toiminto ei ole sallittu.',
    flow_discontinuity_error:
      'Prosessia ei voi jatkaa käyttäjä-asetusten tai palvelun asetusten vuoksi.',
    form_data_invalid_error: 'Lähetetyissä lomaketiedoissa on virheitä.',
    unauthorized: 'Istuntosi on vanhentunut. Kirjaudu uudelleen.',
    value_missing_error: 'Arvo puuttuu.',
    value_too_long_error: 'Arvo on liian pitkä.',
    value_too_short_error: 'Arvo on liian lyhyt.',
    webauthn_credential_invalid_mfa_only:
      'Tätä tunnistetta voi käyttää vain toisena tunnistusvaiheena.',
    webauthn_credential_already_exists:
      'Pyyntö aikakatkaistiin, peruutettiin tai laite on jo rekisteröity. Yritä uudelleen tai käytä toista laitetta.',
    platform_authenticator_required:
      'Tilisi vaatii laitteen oman tunnistimen, mutta nykyinen laite tai selain ei tue sitä.',
    third_party_access_denied:
      'Pääsy evätty. Käyttäjä peruui pyynnön tai palveluntarjoaja esti pääsyn.',
  },
};
